import ResourcePage from "./ResourcePage";

const FIELDS = [
  { name: "title", label: "Title", type: "text" },
  { name: "category", label: "Category", type: "select", options: ["Paintings", "Folk Studies", "Textile Art", "Sketchbook", "Commissions", "Illustrations", "Pata / Folk Work"] },
  { name: "medium", label: "Medium", type: "text" },
  { name: "year", label: "Year", type: "text" },
  { name: "story", label: "Story / inspiration", type: "textarea" },
  { name: "image", label: "Image URL", type: "image" },
  { name: "order", label: "Display order", type: "number" },
  { name: "published", label: "Published", type: "checkbox" },
];

export default function ArtworksAdmin() {
  return (
    <ResourcePage
      title="Folk Art"
      subtitle="Paintings, patachitra work, textile art and sketches shown in the gallery."
      endpoint="/artworks"
      fields={FIELDS}
      testid="artworks"
    />
  );
}
